export const INFO_INCOMPLETE_ERROR_TEXT =
  "Veuillez compléter toutes les informations requises.";

export const INFO_INVALID_PHONE_ERROR_TEXT =
  "Veuillez renseigner un numéro de téléphone valide (sans espaces ni caractères spéciaux).";